export default __webpack_public_path__ + "locales/nl/ChangePortalOwner.json?hash=ff72a2b9e64b8642ee7b7282b992c728";